const PERMISSION_KEY = "core:api_key_permission_group";
const PAGE_URL = {
    API_KEY_PERMISSION_GROUP_PAGE: "/admin/core/api-key-permission-group"
}

export { PERMISSION_KEY, PAGE_URL }
